// Categories matching PRD schema
export const categories = [
  {
    id: '1',
    slug: 'chairs',
    name_de: 'Stühle',
    name_en: 'Chairs',
    name_it: 'Sedie',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '2',
    slug: 'tables',
    name_de: 'Tische',
    name_en: 'Tables',
    name_it: 'Tavoli',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '3',
    slug: 'cabinets',
    name_de: 'Schränke',
    name_en: 'Cabinets',
    name_it: 'Armadi',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '4',
    slug: 'beds',
    name_de: 'Betten',
    name_en: 'Beds',
    name_it: 'Letti',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '5',
    slug: 'lighting',
    name_de: 'Beleuchtung',
    name_en: 'Lighting',
    name_it: 'Illuminazione',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '6',
    slug: 'wood-stoves',
    name_de: 'Kachelöfen',
    name_en: 'Wood Stoves',
    name_it: 'Stufe a Legna',
    created_at: '2025-01-01T00:00:00Z'
  },
  {
    id: '7',
    slug: 'custom',
    name_de: 'Sonderanfertigungen',
    name_en: 'Custom Furnishings',
    name_it: 'Arredi su Misura',
    created_at: '2025-01-01T00:00:00Z'
  }
];

// Mock products matching PRD schema
export const products = [
  {
    id: 'p1',
    slug: 'alpine-dining-chair',
    sku: 'CH-001',
    name_de: 'Alpiner Esszimmerstuhl',
    name_en: 'Alpine Dining Chair',
    name_it: 'Sedia da Pranzo Alpina',
    description_de: 'Handgefertigter Esszimmerstuhl aus heimischem Eichenholz mit traditioneller Schnitzerei.',
    description_en: 'Handcrafted dining chair made from local oak wood with traditional carving.',
    description_it: 'Sedia da pranzo artigianale in legno di quercia locale con intaglio tradizionale.',
    material_de: 'Eichenholz, Naturfaser-Polsterung',
    material_en: 'Oak wood, natural fiber upholstery',
    material_it: 'Legno di quercia, imbottitura in fibra naturale',
    price: 890.00,
    currency: 'EUR',
    dimensions: '45 x 50 x 95 cm',
    image_url: 'https://images.unsplash.com/photo-1652346080508-e2a6b7298450',
    category_id: '1',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  },
  {
    id: 'p2',
    slug: 'farmhouse-dining-table',
    sku: 'TB-001',
    name_de: 'Bauernhaus Esstisch',
    name_en: 'Farmhouse Dining Table',
    name_it: 'Tavolo da Pranzo Rustico',
    description_de: 'Massiver Esstisch aus geöltem Nussholz, perfekt für die ganze Familie.',
    description_en: 'Solid dining table made from oiled walnut wood, perfect for the whole family.',
    description_it: 'Tavolo da pranzo massiccio in legno di noce oliato, perfetto per tutta la famiglia.',
    material_de: 'Nussholz, geölt',
    material_en: 'Walnut wood, oiled',
    material_it: 'Legno di noce, oliato',
    price: 3200.00,
    currency: 'EUR',
    dimensions: '220 x 100 x 76 cm',
    image_url: 'https://images.unsplash.com/photo-1729603369774-23019dbf6c9c',
    category_id: '2',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  },
  {
    id: 'p3',
    slug: 'tyrolean-wardrobe',
    sku: 'CB-001',
    name_de: 'Tiroler Kleiderschrank',
    name_en: 'Tyrolean Wardrobe',
    name_it: 'Armadio Tirolese',
    description_de: 'Traditioneller Kleiderschrank mit handgeschnitzten Verzierungen im Tiroler Stil.',
    description_en: 'Traditional wardrobe with hand-carved Tyrolean style decorations.',
    description_it: 'Armadio tradizionale con decorazioni intagliate a mano in stile tirolese.',
    material_de: 'Zirbenholz',
    material_en: 'Swiss pine wood',
    material_it: 'Legno di cirmolo',
    price: 4500.00,
    currency: 'EUR',
    dimensions: '180 x 60 x 200 cm',
    image_url: 'https://images.unsplash.com/photo-1759753874998-5e0182e07af6',
    category_id: '3',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  },
  {
    id: 'p4',
    slug: 'alpine-platform-bed',
    sku: 'BD-001',
    name_de: 'Alpines Plattformbett',
    name_en: 'Alpine Platform Bed',
    name_it: 'Letto a Piattaforma Alpino',
    description_de: 'Minimalistisches Plattformbett aus massivem Eschenholz mit integriertem Kopfteil.',
    description_en: 'Minimalist platform bed made from solid ash wood with integrated headboard.',
    description_it: 'Letto a piattaforma minimalista in frassino massiccio con testiera integrata.',
    material_de: 'Eschenholz, natur',
    material_en: 'Ash wood, natural',
    material_it: 'Legno di frassino, naturale',
    price: 2800.00,
    currency: 'EUR',
    dimensions: '180 x 200 cm',
    image_url: 'https://images.unsplash.com/photo-1768253843445-49fa5f4a801f',
    category_id: '4',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  },
  {
    id: 'p5',
    slug: 'artisan-table-lamp',
    sku: 'LT-001',
    name_de: 'Handwerker Tischlampe',
    name_en: 'Artisan Table Lamp',
    name_it: 'Lampada da Tavolo Artigianale',
    description_de: 'Elegante Tischlampe mit gedrechseltem Holzfuß und Leinenschirm.',
    description_en: 'Elegant table lamp with turned wooden base and linen shade.',
    description_it: 'Elegante lampada da tavolo con base in legno tornito e paralume in lino.',
    material_de: 'Kirschholz, Leinen',
    material_en: 'Cherry wood, linen',
    material_it: 'Legno di ciliegio, lino',
    price: 450.00,
    currency: 'EUR',
    dimensions: 'H 55 cm, Ø 35 cm',
    image_url: 'https://images.unsplash.com/photo-1759753874998-5e0182e07af6',
    category_id: '5',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  },
  {
    id: 'p6',
    slug: 'traditional-kachelofen',
    sku: 'WS-001',
    name_de: 'Traditioneller Kachelofen',
    name_en: 'Traditional Tile Stove',
    name_it: 'Stufa in Maiolica Tradizionale',
    description_de: 'Klassischer Südtiroler Kachelofen mit handbemalten Kacheln und effizienter Wärmeabgabe.',
    description_en: 'Classic South Tyrolean tile stove with hand-painted tiles and efficient heat output.',
    description_it: 'Classica stufa altoatesina in maiolica con piastrelle dipinte a mano e efficiente emissione di calore.',
    material_de: 'Keramikkacheln, Speckstein',
    material_en: 'Ceramic tiles, soapstone',
    material_it: 'Piastrelle in ceramica, pietra ollare',
    price: 8500.00,
    currency: 'EUR',
    dimensions: '120 x 80 x 180 cm',
    image_url: 'https://images.unsplash.com/photo-1770034343956-fe43ebf663e4',
    category_id: '6',
    is_active: true,
    created_at: '2025-01-01T00:00:00Z',
    updated_at: '2025-01-01T00:00:00Z'
  }
];

// Product images for galleries (matching PRD schema)
export const productImages = [
  { id: 'img1', product_id: 'p1', image_url: 'https://images.unsplash.com/photo-1652346080508-e2a6b7298450', sort_order: 0 },
  { id: 'img2', product_id: 'p2', image_url: 'https://images.unsplash.com/photo-1729603369774-23019dbf6c9c', sort_order: 0 },
  { id: 'img3', product_id: 'p2', image_url: 'https://images.unsplash.com/photo-1724920189974-32612518c0c0', sort_order: 1 },
  { id: 'img4', product_id: 'p3', image_url: 'https://images.unsplash.com/photo-1759753874998-5e0182e07af6', sort_order: 0 },
  { id: 'img5', product_id: 'p4', image_url: 'https://images.unsplash.com/photo-1768253843445-49fa5f4a801f', sort_order: 0 },
  { id: 'img6', product_id: 'p5', image_url: 'https://images.unsplash.com/photo-1759753874998-5e0182e07af6', sort_order: 0 },
  { id: 'img7', product_id: 'p6', image_url: 'https://images.unsplash.com/photo-1770034343956-fe43ebf663e4', sort_order: 0 }
];

// Helper functions
export const getProductsByCategory = (categorySlug) => {
  if (!categorySlug) return products.filter(p => p.is_active);
  const category = categories.find(c => c.slug === categorySlug);
  if (!category) return [];
  return products.filter(p => p.category_id === category.id && p.is_active);
};

export const getProductBySlug = (slug) => {
  return products.find(p => p.slug === slug);
};

export const getCategoryBySlug = (slug) => {
  return categories.find(c => c.slug === slug);
};

export const getCategoryById = (id) => {
  return categories.find(c => c.id === id);
};

export const getProductImages = (productId) => {
  return productImages.filter(img => img.product_id === productId).sort((a, b) => a.sort_order - b.sort_order);
};
